import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-61c7bdec")

_pushScopeId("data-v-61c7bdec")
const _hoisted_1 = { class: "pl-16" }
const _hoisted_2 = { class: "f-medium f-nm df-middle" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "close ml-4"
}
const _hoisted_5 = { class: "c-tip" }
const _hoisted_6 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_7 = { class: "pr-16" }
const _hoisted_8 = { class: "px-6 f-nm" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Pic = _resolveComponent("Pic")
  const _component_Icon = _resolveComponent("Icon")
  const _component_SymbolLink = _resolveComponent("SymbolLink")
  const _component_RealTimeQuote = _resolveComponent("RealTimeQuote")

  return (_openBlock(), _createBlock(_component_RealTimeQuote, { symbol: _ctx.symbol }, {
    default: _withId(({price, buy, spread, margin, mp, isRise}) => [
      _createVNode(_component_SymbolLink, {
        code: _ctx.symbol.code,
        class: "row f-md anchor px-16",
        tag: "tr"
      }, {
        default: _withId(() => [
          _createVNode("td", _hoisted_1, [
            _createVNode(_component_Pic, {
              src: _ctx.symbol.icon,
              width: "32",
              height: "32",
              style: {"border-radius":"50%"}
            }, null, 8, ["src"])
          ]),
          _createVNode("td", null, [
            _createVNode("p", _hoisted_2, [
              _createTextVNode(_toDisplayString(_ctx.symbol && _ctx.symbol.code) + " ", 1),
              (_ctx.count)
                ? (_openBlock(), _createBlock("span", _hoisted_3, "(" + _toDisplayString(_ctx.count) + ")", 1))
                : _createCommentVNode("", true),
              (_ctx.isClosed)
                ? (_openBlock(), _createBlock("span", _hoisted_4, "Closed"))
                : _createCommentVNode("", true),
              (_ctx.marketItem.specialIdentification===1||_ctx.marketItem.specialIdentification===2)
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 2,
                    sm: "",
                    name: "wt_mark",
                    class: "ml-4",
                    style: {"color":"var(--color-primary)"}
                  }))
                : _createCommentVNode("", true)
            ]),
            _createVNode("p", _hoisted_5, _toDisplayString(_ctx.marketItem.tips), 1)
          ]),
          _hoisted_6,
          _createVNode("td", _hoisted_7, [
            _createVNode("span", {
              class: ["f-medium badge-market success", {'danger': !isRise}]
            }, [
              _createVNode("span", _hoisted_8, _toDisplayString(price), 1)
            ], 2),
            _createVNode("p", {
              class: ["c-success mt-4 ", {'c-danger': !isRise}]
            }, _toDisplayString(mp), 3)
          ])
        ]),
        _: 2
      }, 1032, ["code"])
    ]),
    _: 1
  }, 8, ["symbol"]))
})